module.exports = __webpack_public_path__ + "img/fiat-2012-calendar-teaser-04.8408b311.jpg";